import React from 'react';
import classNames from 'classnames';
import css from './Sections.module.css';
import { NamedLink } from '../../../components';
import Icons from '../../../components/Icons/Icons';

const steps = [
  {
    icon: 'browse',
    title: '1. Browse and Select',
    description:
      'Browse our ever-refreshing collection of book pallets.',
  },
  {
    icon: 'checkout',
    title: '2. Easy Checkout',
    description: 'Checkout with your selections with easy payment and instant shipping quotes. ',
  },
  {
    icon: 'delivery',
    title: '3. Direct Delivery',
    description:
      "Sit back and relax; we'll bring your books right to your doorstep. Fast, direct, and hassle-free.",
  },
];

function Step({ step }) {
  return (
    <div className={css.block}>
      <div className={css.icons}>
        <Icons name={step.icon} />
      </div>
      <h3>{step.title}</h3>
      <p>{step.description}</p>
    </div>
  );
}

function SectionHowItWorks(props) {
  return (
    <div className={classNames(css.howItWorks, css.sectionPadding)}>
      <div className={css.fixedWidthContainer}>
        <div className={css.contentWidth}>
          <div className={css.sectionHead}>
            <h2 className={css.sectionTitle}>How it works?</h2>
          </div>
          <div className={css.sectionContent}>
            {steps.map((step, index) => (
              <Step key={index} step={step} />
            ))}
          </div>
          <div className={css.learnMore}>
            <NamedLink className={css.findLink} name="SearchPage">
              Learn more
            </NamedLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionHowItWorks;
